/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.BusinessReviewUserSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The BusinessReviewUserSettings model module.
   * @module model/BusinessReviewUserSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>BusinessReviewUserSettings</code>.
   * @alias module:model/BusinessReviewUserSettings
   * @class
   */
  var exports = function() {
    var _this = this;



















  };

  /**
   * Constructs a <code>BusinessReviewUserSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BusinessReviewUserSettings} obj Optional instance to populate.
   * @return {module:model/BusinessReviewUserSettings} The populated <code>BusinessReviewUserSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('UserID')) {
        obj['UserID'] = ApiClient.convertToType(data['UserID'], 'Integer');
      }
      if (data.hasOwnProperty('PeriodTypeID')) {
        obj['PeriodTypeID'] = ApiClient.convertToType(data['PeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('EmbeddedMetrics')) {
        obj['EmbeddedMetrics'] = ApiClient.convertToType(data['EmbeddedMetrics'], 'Boolean');
      }
      if (data.hasOwnProperty('ShowExcludedItems')) {
        obj['ShowExcludedItems'] = ApiClient.convertToType(data['ShowExcludedItems'], 'Boolean');
      }
      if (data.hasOwnProperty('ShowStrategy')) {
        obj['ShowStrategy'] = ApiClient.convertToType(data['ShowStrategy'], 'Boolean');
      }
      if (data.hasOwnProperty('ShowGoals')) {
        obj['ShowGoals'] = ApiClient.convertToType(data['ShowGoals'], 'Boolean');
      }
      if (data.hasOwnProperty('ShowGoalsMetrics')) {
        obj['ShowGoalsMetrics'] = ApiClient.convertToType(data['ShowGoalsMetrics'], 'Boolean');
      }
      if (data.hasOwnProperty('ShowBreakthrough')) {
        obj['ShowBreakthrough'] = ApiClient.convertToType(data['ShowBreakthrough'], 'Boolean');
      }
      if (data.hasOwnProperty('ShowBreakthroughStatusUpdates')) {
        obj['ShowBreakthroughStatusUpdates'] = ApiClient.convertToType(data['ShowBreakthroughStatusUpdates'], 'Boolean');
      }
      if (data.hasOwnProperty('ShowBreakthroughMetrics')) {
        obj['ShowBreakthroughMetrics'] = ApiClient.convertToType(data['ShowBreakthroughMetrics'], 'Boolean');
      }
      if (data.hasOwnProperty('ShowBreakthroughActions')) {
        obj['ShowBreakthroughActions'] = ApiClient.convertToType(data['ShowBreakthroughActions'], 'Boolean');
      }
      if (data.hasOwnProperty('ShowBreakthroughActionsComments')) {
        obj['ShowBreakthroughActionsComments'] = ApiClient.convertToType(data['ShowBreakthroughActionsComments'], 'Boolean');
      }
      if (data.hasOwnProperty('Show2NdLevelBr')) {
        obj['Show2NdLevelBr'] = ApiClient.convertToType(data['Show2NdLevelBr'], 'Boolean');
      }
      if (data.hasOwnProperty('Show2NdLevelBrStatusUpdates')) {
        obj['Show2NdLevelBrStatusUpdates'] = ApiClient.convertToType(data['Show2NdLevelBrStatusUpdates'], 'Boolean');
      }
      if (data.hasOwnProperty('Show2NdLevelBrMetrics')) {
        obj['Show2NdLevelBrMetrics'] = ApiClient.convertToType(data['Show2NdLevelBrMetrics'], 'Boolean');
      }
      if (data.hasOwnProperty('Show2NdLevelBrActions')) {
        obj['Show2NdLevelBrActions'] = ApiClient.convertToType(data['Show2NdLevelBrActions'], 'Boolean');
      }
      if (data.hasOwnProperty('Show2NdLevelBrActionsComments')) {
        obj['Show2NdLevelBrActionsComments'] = ApiClient.convertToType(data['Show2NdLevelBrActionsComments'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} UserID
   */
  exports.prototype['UserID'] = undefined;
  /**
   * @member {Integer} PeriodTypeID
   */
  exports.prototype['PeriodTypeID'] = undefined;
  /**
   * @member {Boolean} EmbeddedMetrics
   * @default false
   */
  exports.prototype['EmbeddedMetrics'] = false;
  /**
   * @member {Boolean} ShowExcludedItems
   * @default false
   */
  exports.prototype['ShowExcludedItems'] = false;
  /**
   * @member {Boolean} ShowStrategy
   * @default false
   */
  exports.prototype['ShowStrategy'] = false;
  /**
   * @member {Boolean} ShowGoals
   * @default false
   */
  exports.prototype['ShowGoals'] = false;
  /**
   * @member {Boolean} ShowGoalsMetrics
   * @default false
   */
  exports.prototype['ShowGoalsMetrics'] = false;
  /**
   * @member {Boolean} ShowBreakthrough
   * @default false
   */
  exports.prototype['ShowBreakthrough'] = false;
  /**
   * @member {Boolean} ShowBreakthroughStatusUpdates
   * @default false
   */
  exports.prototype['ShowBreakthroughStatusUpdates'] = false;
  /**
   * @member {Boolean} ShowBreakthroughMetrics
   * @default false
   */
  exports.prototype['ShowBreakthroughMetrics'] = false;
  /**
   * @member {Boolean} ShowBreakthroughActions
   * @default false
   */
  exports.prototype['ShowBreakthroughActions'] = false;
  /**
   * @member {Boolean} ShowBreakthroughActionsComments
   * @default false
   */
  exports.prototype['ShowBreakthroughActionsComments'] = false;
  /**
   * @member {Boolean} Show2NdLevelBr
   * @default false
   */
  exports.prototype['Show2NdLevelBr'] = false;
  /**
   * @member {Boolean} Show2NdLevelBrStatusUpdates
   * @default false
   */
  exports.prototype['Show2NdLevelBrStatusUpdates'] = false;
  /**
   * @member {Boolean} Show2NdLevelBrMetrics
   * @default false
   */
  exports.prototype['Show2NdLevelBrMetrics'] = false;
  /**
   * @member {Boolean} Show2NdLevelBrActions
   * @default false
   */
  exports.prototype['Show2NdLevelBrActions'] = false;
  /**
   * @member {Boolean} Show2NdLevelBrActionsComments
   * @default false
   */
  exports.prototype['Show2NdLevelBrActionsComments'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


